import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class transformAttributeService {
  absoluteValue(value: number): number {
    return _isNumberValue(value) ? Math.abs(Number(value)) : 0;
  }

  imageServiceIsSvg(inputUrl: string): boolean {
    const link: URL = new URL(inputUrl);
    return link.pathname.endsWith('.svg');
  }

  imageServiceUrl(
    inputUrl: string,
    width: number = 400,
    height: number = 0
  ): string {
    if (inputUrl.endsWith('.svg')) {
      return inputUrl;
    } else {
      return inputUrl + '/m/' + width + 'x' + height;
    }
  }
}

// Helper functions, not to be exported.
function _isNumberValue(value: any): boolean {
  return !isNaN(parseFloat(value as any)) && !isNaN(Number(value));
}
